// extracted by mini-css-extract-plugin
export default {"container":"S01_container__qmweG","limiter":"S01_limiter__I-Mbp","title":"S01_title__6iEOQ","text":"S01_text__GBZCG","product":"S01_product__yri5N"};